// Edges that can have a drawer applied
const EDGES = ['start', 'bottom'];

// Types of Available Drawers
const TYPES = ['app-menu', 'action-sheet', 'module-nav'];

export { EDGES, TYPES };
